import { isValid, isMatch, parse } from 'date-fns';

/**
 * string 형식의 날짜를 Date 타입으로 변환한다.
 * @param {string} date_str
 * @param {string} format date-fns parse 함수의 dateFormat
 * @return {Date|null}
 */
export const parseStringifyDate = (date_str, format) => {
  // check invalid params
  if (!date_str || !format) {
    return null;
  }

  // trim string
  date_str = date_str.trim();
  if (!isMatch(date_str, format)) {
    return null;
  }

  const date = parse(date_str, format, new Date());
  return isValid(date) ? date : null;
};

/**
 * yyyyMMdd 형식의 string을 Date 타입으로 변환한다.
 * @param {string} date_str
 * @return {Date|null}
 */
export const parseStringifyDate_yyyyMMdd = (date_str) => {
  return parseStringifyDate(date_str, 'yyyyMMdd');
};

export const getKoreanDayOfWeek = (date = new Date()) => {
  const daysOfWeek = ['일', '월', '화', '수', '목', '금', '토'];
  const dayIndex = date.getDay();
  return daysOfWeek[dayIndex];
};

export const getFormattedLocalDate = (date = new Date(), joinStr = '') => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return [year, month, day].join(joinStr);
};

/**
 * @description 특정 기간 안에 존재하는 Date 인지 확인 - 시작일 종료일은 nullable 이나, 둘중 하나는 존재해야 함.
 * @param {Date | null} from - 시작일 (nullable)
 * @param {Date | null} to - 종료일 (nullable)
 * @param {Date} checkDate - 체크하려는 날짜
 * @returns {boolean} checkDate가 기간 내에 존재하면 true, 아니면 false
 */
export const isDateInPeriod = (from = null, to = null, checkDate) => {
  if (!(checkDate instanceof Date)) throw new Error('체크할 시간을 입력하세요');

  const checkTime = checkDate.getTime();
  const fromTime = from instanceof Date ? from.getTime() : null;
  const toTime = to instanceof Date ? to.getTime() : null;

  if (fromTime === null && toTime === null) {
    throw new Error('시작시간과 종료시간 중 하나는 존재해야 합니다.');
  }

  // 둘 다 있는 경우
  if (fromTime !== null && toTime !== null) {
    return checkTime >= fromTime && checkTime <= toTime;
  }

  // from만 있는 경우
  if (fromTime !== null) {
    return checkTime >= fromTime;
  }

  // to만 있는 경우
  return checkTime <= toTime;
};
